// ============================================================================
// dataTypes/liveStreamManagment/sourceRegistry/acquirers/ScreenAcquirer.ts
// Acquiert un flux de partage d'écran via getDisplayMedia.
// ============================================================================

import { Source, SourceAcquirer, ScreenSourceConfig } from '../types';

export class ScreenAcquirer implements SourceAcquirer {

  private readonly _cleanups = new Map<string, () => void>();

  async acquire(source: Source): Promise<MediaStream> {
    const config = source.config as ScreenSourceConfig;

    const stream = await (navigator.mediaDevices as any).getDisplayMedia({
      video: {
        width:     { ideal: config.width     ?? 1920 },
        height:    { ideal: config.height    ?? 1080 },
        frameRate: { ideal: config.frameRate ?? 30 },
        cursor:    config.cursor ?? 'always',
      },
      audio: config.withAudio ?? false,
    });

    // L'utilisateur peut fermer le partage via le bouton natif du navigateur.
    // On écoute l'événement 'ended' sur la track vidéo pour que le registry
    // puisse réagir (remettre la source en 'idle').
    const videoTrack = stream.getVideoTracks()[0];
    if (videoTrack) {
      const onEnded = () => {
        console.log(`[ScreenAcquirer] Partage d'écran arrêté par l'utilisateur (${source.id})`);
      };
      videoTrack.addEventListener('ended', onEnded);
      this._cleanups.set(source.id, () => videoTrack.removeEventListener('ended', onEnded));
    }

    return stream;
  }

  release(source: Source): void {
    this._cleanups.get(source.id)?.();
    this._cleanups.delete(source.id);
    if (source.stream) {
      source.stream.getTracks().forEach(track => track.stop());
    }
  }
}
